import { useToast } from '@app/core/notifications';
import { useSocialExportDeleteUpload, useSocialExportPromoteUpload } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';
import { publishCardMessages } from '../publish-messages';

type Params = {
  onDeleteSuccess: (uploadId: string) => Promise<void>;
  onPromoteSuccess: (uploadId: string) => Promise<void>;
};

/**
 * Delete and promote mutations for a social upload card, with toast notifications.
 */
export function useUploadCardMutations({ onDeleteSuccess, onPromoteSuccess }: Params) {
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  const deleteMutation = useSocialExportDeleteUpload({
    mutation: {
      onSuccess: async (_data, variables) => {
        await onDeleteSuccess(variables.id);
        notifySuccess($t(publishCardMessages.videoDeletedFromPlatform));
      },
      onError: (error: Error) => {
        notifyError(error?.message || $t(publishCardMessages.errorDeletingVideo));
      },
    },
  });

  const promoteMutation = useSocialExportPromoteUpload({
    mutation: {
      onSuccess: async (_data, variables) => {
        await onPromoteSuccess(variables.id);
        notifySuccess($t(publishCardMessages.publicationStarted));
      },
      onError: (error: Error) => {
        notifyError(error?.message || $t(publishCardMessages.errorPublishingNow));
      },
    },
  });

  return { deleteMutation, promoteMutation };
}
